// src/ReturContext.js
import { createContext } from 'react';

export const ReturContext = createContext({
  returEmail: '',
  returNume: '',
  returTelefon: '',
});
